// TODO: Move to a central logger
export const logError = (route: string | null, error: Error) => {
    //NOTE: No central error handling exists at this time. Logging to console to assist debugging.
    console.log(`service network error -> ${error.message}. Route -> ${route}`);
};
